import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/PemantauanTtvHarian";

export interface IfcPemantauanTtvHarian {
  id: number;
  register_id: number;
  pasien_rm: string;
  tanda_vital_id: number | null;
  tanggal: string;
  jam: string;
  oksigen_lpm: number | null;
  mobilisasi: "B" | "D" | "J" | null;
  jenis_cairan: string | null;
  tpm: number | null;
  jenis_transfusi: string | null;
  volume_transfusi: number | null;
  jumlah_makan: string | null;
  volume_minum: number | null;
  volume_bak: number | null;
  bab: string | null;
  volume_muntah: number | null;
  volume_drainase: number | null;
  iwl: number | null;
  balance_cairan: number | null;
  catatan: string | null;
  user: {
    id: number;
    nama: string;
  };
  tanda_vital: any | null;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "pemantauan-ttv-harian"
})
class PemantauanTtvHarianStore extends VuexModule {
  loading = false;
  rawList: Array<IfcPemantauanTtvHarian> = [];

  get list(): Array<IfcPemantauanTtvHarian> {
    return [...this.rawList].sort((a, b) => {
      const dateA = new Date(`${a.tanggal}T${a.jam}`).getTime();
      const dateB = new Date(`${b.tanggal}T${b.jam}`).getTime();
      return dateA - dateB;
    });
  }

  @Mutation
  SET_RAWLIST(val: Array<IfcPemantauanTtvHarian>) {
    this.rawList = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.rawList = [];
  }

  @Action({ rawError: true })
  async getByRegister(regId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(regId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_RAWLIST(response.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(PemantauanTtvHarianStore);
